import type { User } from "@prisma/client";
import Link from "next/link";
import { UserCircleIcon } from "@heroicons/react/24/outline";
import Image from "next/image";

export default function UserIcon({
  user,
  showDisplayName,
  size,
  link,
}: {
  user: User;
  showDisplayName: boolean;
  size: number;
  link: boolean;
}) {
  const component = (
    <div className="flex items-center gap-x-2.5">
      {user.image ? (
        <Image
          src={user.image}
          alt={`${user.displayName} icon`}
          className={`h-${size} w-${size} flex-none rounded-full border border-white`}
          width="128"
          height="128"
        />
      ) : (
        <UserCircleIcon className={`bg-wthie h-${size} w-${size}`} />
      )}
      {showDisplayName && <>{user.displayName}</>}
    </div>
  );

  return (
    <>
      {link ? (
        <Link href={`/v1/users/${user.id}`} prefetch={false}>
          {component}
        </Link>
      ) : (
        component
      )}
    </>
  );
}
